export enum VALID_STATE {
  NONE = 'none',
  PASS = 'pass',
  ERROR = 'error',
}

export const LOGIN_EMAIL_VALIDATE_ERROR: {
  [key: string]: string;
} = {
  required: 'login/email_validate_required_error',
  pattern: 'login/email_validate_pattern_error',
};

export const PASSWORD_RESET_EMAIL_VALIDATE_ERROR: {
  [key: string]: string;
} = {
  required: 'password/reset/email_validate_required_error',
  pattern: 'login/email_validate_pattern_error',
};

export const LOGIN_PASSWORD_VALIDATE_ERROR: {
  [key: string]: string;
} = {
  required: 'login/password_validate_required_error',
};

export const ACCOUNT_COUNTRY_VALIDATE_ERROR: {
  [key: string]: string;
} = {
  required: 'account/age/country_validate_required_error',
};

export const ACCOUNT_BIRTH_VALIDATE_ERROR: {
  [key: string]: string;
} = {
  required: 'account/age/birth_validate_required_error',
};

export const ACCOUNT_EMAIL_VALIDATE_ERROR: {
  [key: string]: string;
} = {
  required: 'account/form/email_validate_required_error',
  pattern: 'login/email_validate_pattern_error',
};

export const ACCOUNT_PASSWORD_VALIDATE_ERROR: {
  [key: string]: string;
} = {
  required: 'account/form/password_validate_required_error',
  min: 'account/form/password_validate_min_error',
  pattern: 'account/form/password_validate_pattern_error',
};

export const ACCOUNT_PASSWORD_CONFIRM_VALIDATE_ERROR: {
  [key: string]: string;
} = {
  required: 'account/form/password_confirm_validate_required_error',
  match: 'account/form/password_confirm_validate_match_error',
};

export const PROMOTION_VALIDATE_ERROR: Record<string, string> = {
  verify: 'payment/promotion_validate_verify_error',
  required: 'payment/promotion_validate_required_error',
};
